import { useOkapiKy } from '@folio/stripes/core';
import { useQuery } from 'react-query';
import { fetchPendingApprovalReport } from '../api/proposalService';
/**
 * CZNA-553 — fetches the printable list of proposals awaiting approval.
 *
 * `params` is null while the period on screen is not a usable one (empty, malformed or
 * inverted); the query is then disabled rather than sent, so a half-typed date does not
 * produce a 400 the user has to read as an error.
 */
var usePendingApprovalReport = function (params) {
    var _a;
    var ky = useOkapiKy();
    var _b = useQuery(['proposal-pending-report', params === null || params === void 0 ? void 0 : params.from, params === null || params === void 0 ? void 0 : params.to, (_a = params === null || params === void 0 ? void 0 : params.recordType) !== null && _a !== void 0 ? _a : null], function () { return fetchPendingApprovalReport(ky, params); }, { enabled: !!params, keepPreviousData: false }), data = _b.data, isLoading = _b.isLoading, isFetching = _b.isFetching, isError = _b.isError, error = _b.error, refetch = _b.refetch;
    return { report: data, isLoading: isLoading, isFetching: isFetching, isError: isError, error: error, refetch: refetch };
};
export default usePendingApprovalReport;
